import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft, FaCapsules } from "react-icons/fa";
import Header from "../../components/IntranetHeader";
import Footer from "../../components/Footer";
import { loadDrugMatrix } from "../../lib/drugMatrix";

const sections = [
  ["Description", "description"],
  ["Indications", "indications"],
  ["Dosage / administration notes", "dosage_notes"],
  ["Contraindications", "contraindications"],
  ["Warnings / cautions", "warnings"],
  ["Additional notes", "additional_notes"],
];

export default function DrugMatrixDetail({ session, profile }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [drug, setDrug] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    loadDrugMatrix()
      .then((result) => {
        if (!active) return;
        const found = result.drugs.find((item) => item.slug === slug);
        if (!found) setError("This medicine could not be found in the Drug Matrix.");
        else setDrug(found);
      })
      .catch((err) => { if (active) setError(err.message || "Could not load this medicine."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [slug]);

  return <>
    <Header session={session} profile={profile} />
    <main className="nhsuk-main-wrapper pguh-drug-matrix" id="main-content" tabIndex="-1">
      <div className="nhsuk-width-container pguh-drug-page-shell">
        <button type="button" className="pguh-back-link-button" onClick={() => navigate("/intranet/drug-matrix")}><FaArrowLeft /> Back to Drug Matrix</button>
        {loading && <div className="pguh-drug-empty"><p>Loading medicine…</p></div>}
        {error && <div className="nhsuk-error-summary"><h2 className="nhsuk-error-summary__title">Medicine unavailable</h2><div className="nhsuk-error-summary__body"><p>{error}</p></div></div>}
        {drug && <>
          <header className="pguh-drug-detail-hero">
            <div className="pguh-drug-detail-hero__icon"><FaCapsules /></div>
            <div className="pguh-drug-detail-hero__copy"><span className="pguh-eyebrow">{drug.category?.name}</span><h1>{drug.name}</h1>{drug.alternative_name && <p>Alternative / generic name: <strong>{drug.alternative_name}</strong></p>}</div>
          </header>

          {drug.labels.length > 0 && <section className="pguh-drug-admin-box"><span className="pguh-eyebrow">Administration labels</span><h2>Who can administer</h2><div className="pguh-drug-labels pguh-drug-labels--large">{drug.labels.filter((item) => item.active).map((item) => <span key={item.id} title={item.description || undefined}>{item.name}</span>)}</div></section>}

          <div className="pguh-drug-detail-sections">{sections.map(([title, key]) => drug[key] ? <section key={key}><h2>{title}</h2><div className="pguh-drug-rich-text">{String(drug[key]).split(/\n+/).map((line, index) => <p key={`${key}-${index}`}>{line}</p>)}</div></section> : null)}</div>

          <div className="nhsuk-inset-text pguh-drug-disclaimer"><strong>Important:</strong> This Drug Matrix is an internal RUHT reference. Follow current Trust guidance, competency limits and authorised prescribing/administration procedures.</div>
        </>}
      </div>
    </main>
    <Footer />
  </>;
}
